import { Box } from '@mui/material'
import React from 'react'
import { HeaderTab, HeaderWrap, Tab, TabLabel } from './style'

const DEFAULT_OPTIONS = [
  { id: 0, label: 'Comparison View' },
  { id: 1, label: 'Segment  View' },
]

const Header = ({ onChange, value, options = DEFAULT_OPTIONS, styletype }) => {
  const isThemeV2 = styletype === 'themeV2'
  return (
    <HeaderWrap className={`tabsWrapper ${styletype === 'themeV2' ? 'themeV2' : ''}`}>
      <Box className='tableFirstCol headerFirst'></Box>
      <HeaderTab className='headerLastCol'>
        {options?.map((item) => {
          const joinOptions =
            options
              .map((o) => o.label)
              .join('')
              .replaceAll(' ', '') + item.id
          const tutorialClass = item?.tutorial
            ? 'tabTutorial_' + item.tutorial.replaceAll(' ', '-').split('-')[0]
            : ''
          return isThemeV2 ? (
            <Tab key={item.id} className={`tab ${joinOptions} ${tutorialClass}`}>
              <TabLabel active={value === item.id} onClick={() => onChange(item.id)}>
                {item.label}
              </TabLabel>
            </Tab>
          ) : (
            <Box
              key={item.id}
              className={`tab ${joinOptions} ${value === item.id ? 'active' : ''} ${tutorialClass}`}
            >
              <Box onClick={() => onChange(item.id)}>{item.label}</Box>
            </Box>
          )
        })}
      </HeaderTab>
    </HeaderWrap>
  )
}

export default Header
